var exports = {
  "tb": "UserProfileModal.module__noteTextarea___c3VtVk",
  "CR": "UserProfileModal.module__modalRoot___c3VtVk",
  "eF": "UserProfileModal.module__userInfo___c3VtVk",
  "hR": "UserProfileModal.module__userInfoHeader___c3VtVk",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___c3VtVk",
  "Rn": "UserProfileModal.module__userInfoContent___c3VtVk",
  "yn": "UserProfileModal.module__profileDataWarning___c3VtVk",
  "S7": "UserProfileModal.module__nameRow___c3VtVk",
  "nT": "UserProfileModal.module__userName___c3VtVk",
  "a1": "UserProfileModal.module__userTag___c3VtVk",
  "Fj": "UserProfileModal.module__usernameRow___c3VtVk",
  "hI": "UserProfileModal.module__pronouns___c3VtVk",
  "sM": "UserProfileModal.module__srOnly___c3VtVk",
  "Li": "UserProfileModal.module__customStatusText___c3VtVk",
  "Ef": "UserProfileModal.module__customStatusRow___c3VtVk",
  "_z": "UserProfileModal.module__tagBadgeRow___c3VtVk",
  "U3": "UserProfileModal.module__badgesWrapper___c3VtVk",
  "ZV": "UserProfileModal.module__userNoteEditor___c3VtVk",
  "xu": "UserProfileModal.module__noteLabel___c3VtVk",
  "_j": "UserProfileModal.module__noteTextareaBase___c3VtVk",
  "jd": "UserProfileModal.module__noteTextareaEditing___c3VtVk",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___c3VtVk",
  "bs": "UserProfileModal.module__profileContent___c3VtVk",
  "EM": "UserProfileModal.module__profileContentHeader___c3VtVk",
  "cI": "UserProfileModal.module__bannerContainer___c3VtVk",
  "HG": "UserProfileModal.module__bannerMask___c3VtVk",
  "_e": "UserProfileModal.module__bannerImage___c3VtVk",
  "N1": "UserProfileModal.module__headerContainer___c3VtVk",
  "H": "UserProfileModal.module__avatarContainer___c3VtVk",
  "fc": "UserProfileModal.module__actionButtonsContainer___c3VtVk",
  "hQ": "UserProfileModal.module__contentContainer___c3VtVk",
  "sq": "UserProfileModal.module__profileContentWrapper___c3VtVk",
  "zL": "UserProfileModal.module__scrollerFullHeight___c3VtVk",
  "jT": "UserProfileModal.module__modalContainer___c3VtVk",
  "uu": "UserProfileModal.module__actionButtons___c3VtVk",
  "iA": "UserProfileModal.module__buttonIcon___c3VtVk",
  "ro": "UserProfileModal.module__menuIcon___c3VtVk",
  "WB": "UserProfileModal.module__avatarFocusRing___c3VtVk",
  "VS": "UserProfileModal.module__tabsWrapper___c3VtVk",
  "OT": "UserProfileModal.module__mutualFriendsList___c3VtVk",
  "Z8": "UserProfileModal.module__mutualSectionDivider___c3VtVk",
  "KF": "UserProfileModal.module__mutualFriendItem___c3VtVk",
  "vu": "UserProfileModal.module__active___c3VtVk",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___c3VtVk",
  "D9": "UserProfileModal.module__mutualFriendInfo___c3VtVk",
  "eV": "UserProfileModal.module__mutualFriendName___c3VtVk",
  "zD": "UserProfileModal.module__mutualFriendUsername___c3VtVk",
  "p$": "UserProfileModal.module__emptyState___c3VtVk",
  "Ny": "UserProfileModal.module__mutualGuildIcon___c3VtVk",
  "me": "UserProfileModal.module__separator___c3VtVk",
  "AI": "UserProfileModal.module__emptyStateIcon___c3VtVk",
};

module.exports = exports;
